import { render, staticRenderFns } from "./lighting-a45.vue?vue&type=template&id=c17a1f24&"
import script from "./lighting-a45.vue?vue&type=script&lang=js&"
export * from "./lighting-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports